// eslint-disable-next-line no-shadow
export enum CriticalAlertTypeEnum {
  TREATS = 'threats',
  VULNERABILITIES = 'vulnerabilities',
  REGULATIONS = 'regulations',
}
